import { PaginationRequest, Pagination } from "../types/pagination.type";
import { ReportFilterStation, ReportParameterStation } from "../types/report.type";
import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";

/**
 * report parameters
 * @param page
 * @param size
 * @param filter
 * @param timeZone
 * @returns
 */
export const getReportParameters = (
  page: number | undefined,
  size: number | undefined,
  filter: ReportFilterStation,
  timeZone = "UTC"
): Promise<Pagination<ReportParameterStation>> => {
  const params: PaginationRequest<ReportFilterStation> = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }

  return axios
    .get(`/report/datastation/`, {
      params: { ...params, timeZone },
    })
    .then(responseHandlerDefault);
};

/**
 * report parameters
 * @param filter
 * @param timeZone
 * @returns
 */
export const downloadReportParameters = (
  filter: ReportFilterStation,
  timeZone = "UTC"
): Promise<{ fileName: string; url: string }> => {
  return axios
    .post(
      `/report/datastation/csv`,
      {
        filter,
        timeZone,
      },
      { responseType: "blob" }
    )
    .then((res) => {
      responseHandlerDefault(res);
      const match = res.headers["content-disposition"]?.match(/filename\s*=\s*"(.+)"/i);
      const fileName = match && match[1] ? match[1] : "report.csv";

      return { fileName, url: URL.createObjectURL(res.data) };
    });
};
